<template>
  <b-modal
    id="mc-modal-confirm"
    ref="mc-modal-confirm"
    class="mc-modal"
    size="md"
    centered
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    :title="mapping?.title()"
  >
    <div class="card-body p-2">
      <McAlert withIcon class="w-100 mb-3" variant="warning" :text="mapping?.alertText()" />
      <template v-if="type === 'finish-fleet-task'">
        <p v-html="$t('fleetTaskInstant.confirmModal.finishAssignment.content.desc')" />
        <p>{{ $t('fleetTaskInstant.confirmModal.finishAssignment.content.question') }}</p>
      </template>
      <div v-else>
        {{ mapping?.content() }}
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="handleCancel(cancel)"
        />
        <McButton variant="primary" :text="mapping?.confirmBtn()" @click="handleConfirm" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McAlert from '@/components/McAlert'
import McButton from '@/components/McButton'
import confirmModalMappings from '../lib/constants/confirm-modal-mappings.js'

export default {
  components: {
    McAlert,
    McButton,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    transitionStatus: {
      type: String,
      default: 'DRAFT',
    },
  },
  emits: ['transition', 'cancel'],
  computed: {
    mapping() {
      return confirmModalMappings[this.type]
    },
  },
  methods: {
    handleCancel(cancel) {
      cancel()
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$bvModal.hide('mc-modal-confirm')
      this.$emit('transition', this.transitionStatus, true)
    },
  },
}
</script>
